<template>
  <div class="main-user">
    <el-row>
      <my-collapse accordion class="searchForm-colleapse">
        <my-collapse-item>
          <template slot="title">
            <el-form
              :inline="true"
              :model="searchForm"
              class="demo-form-inline search-form"
              size="small"
            >
              <el-form-item style="width: 80px;">
                <el-input
                  v-model="searchForm.realName"
                  placeholder="姓名"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item style="width: 100px;">
                <el-input
                  v-model="searchForm.idNumber"
                  placeholder="证件号码"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item style="width: 100px;">
                <el-input
                  v-model="searchForm.examName"
                  placeholder="考场名称"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item style="width: 100px;">
                <el-select
                  v-model="searchForm.storageStatus"
                  placeholder="证书状态"
                  clearable
                  :default-first-option="true"
                >
                  <el-option
                    v-for="item in storageStatusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item style="width: 210px;">
                <el-date-picker
                    style="width: 100%;"
                    v-model="issuingDates"
                    clearable
                    type="daterange"
                    start-placeholder="发证开始日期"
                    end-placeholder="发证结束日期"
                    value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item style="width: 210px;">
                <el-date-picker
                    style="width: 100%;"
                    v-model="assessCompleteTimes"
                    clearable
                    type="daterange"
                    start-placeholder="测评完成开始日期"
                    end-placeholder="测评完成结束日期"
                    value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button
                  type="primary"
                  @click="onSearchUserCerPager"
                  icon="el-icon-search"
                  >查询
                </el-button>
              </el-form-item>
            </el-form>
          </template>
          <el-form
            :inline="true"
            :model="searchForm"
            class="demo-form-inline search-form"
            size="small"
          >
            <el-form-item style="width: 20.2%;">
              <el-date-picker
                style="width: 100%;"
                v-model="storageTimes"
                clearable
                type="daterange"
                start-placeholder="入库开始日期"
                end-placeholder="入库结束日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
          </el-form>
        </my-collapse-item>
      </my-collapse>
    </el-row>
    <el-row class="button">
      <el-button
          v-permission="['user:userCertificate:exportUserCertificate']"
          size="small" @click="exportInfo">
        导出信息
      </el-button>
      <el-button
          v-permission="['user:userCertificate:exportUserCertificateZip']"
          size="small" @click="exportZipHandler">
        导出zip
      </el-button>
    </el-row>
    <el-card shadow="never" class="card-fix-height scrollable">
      <el-table
        :data="tableData"
        v-loading="loading"
        row-key="id"
        stripe
        @selection-change="handleSelectionChange"
        style="width: 100%;overflow-y: auto"
        :height="tableHeight"
      >
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-form-item label="考场名称:">
                <span>{{ props.row.examName }}</span>
              </el-form-item>
<!--              <el-form-item label="项目编号:">-->
<!--                <span>{{ props.row.projectCode }}</span>-->
<!--              </el-form-item>-->
              <el-form-item label="用户姓名:">
                <span>{{ props.row.realName }}</span>
              </el-form-item>
              <el-form-item label="证件号码:">
                <span>{{ props.row.idNumber }}</span>
              </el-form-item>
              <el-form-item label="证书编号:">
                <span>{{ props.row.certificateCode }}</span>
              </el-form-item>
              <el-form-item label="机构:">
                <span>{{ props.row.agentName }}</span>
              </el-form-item>
              <el-form-item label="证书状态:">
                <span>{{
                    props.row.storageStatus == 0 || props.row.storageStatus == null ? "未生成"
                    : props.row.storageStatus == 3 ? "已入库"
                    : props.row.storageStatus == 4 ? "已过期" : "已生成"
                }}</span>
              </el-form-item>
              <el-form-item label="入库时间:">
                <span>{{ props.row.storageTime }}</span>
              </el-form-item>
              <el-form-item label="纸质证书状态:">
                <span>{{
                  props.row.paperStatus == 2 ? "已发放" : "未发放"
                }}</span>
              </el-form-item>
              <el-form-item label="发证时间:">
                <span>{{ props.row.issuingDate }}</span>
              </el-form-item>
              <el-form-item label="测评完成时间:">
                <span>{{ props.row.assessCompleteTime }}</span>
              </el-form-item>
              <el-form-item label="证书导出状态:">
                <span>{{ props.row.isExport == 1 ? "已导出" : "未导出" }}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column
          prop="examName"
          label="考场名称"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="realName"
          label="用户姓名"
          show-overflow-tooltip
        ></el-table-column>
        <!--<el-table-column
                  prop="idNumber"
                  label="证件号码"
                  show-overflow-tooltip
                ></el-table-column>-->
        <el-table-column
          prop="certificateCode"
          label="证书编号"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="agentName"
          label="机构"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="storageStatus"
          label="证书状态"
          show-overflow-tooltip
          :formatter="storageStatusFormatter"
        ></el-table-column>
        <el-table-column
          prop="issuingDate"
          label="发证时间"
          show-overflow-tooltip
          :formatter="cerDateForMatter"
        ></el-table-column>
        <el-table-column
          prop="assessCompleteTime"
          label="测评完成时间"
          show-overflow-tooltip
          :formatter="cerDateForMatter"
        ></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-tooltip
              v-permission="['user:userCertificate:viewUserCertificate']"
              class="item"
              effect="dark"
              content="电子证书"
              placement="top-start"
            >
              <el-button
                icon="el-icon-view"
                type="primary"
                size="mini"
                circle
                @click="viewCer(scope.row)"
                :disabled="scope.row.certificateCode == null ? true : false"
              ></el-button>
              >
            </el-tooltip>
            <el-tooltip
              v-permission="['user:userCertificate:viewRecommendation']"
              class="item"
              effect="dark"
              content="推荐信"
              placement="top-start"
              v-if="scope.row.recommendation == 1 ? true : false"
            >
              <el-button
                icon="el-icon-message"
                type="primary"
                size="mini"
                circle
                @click="viewRec(scope.row)"
              ></el-button>
              >
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-pagination
      class="footer"
      background
      :layout="tableLayout"
      :total="tableTotal"
      :current-page="currentPage"
      :page-size.sync="pageSize"
      @current-change="onCurrentPageChange"
      @size-change="handleSizeChange"
      :page-sizes="[20, 100, 500]"
      align="center"
    >
    </el-pagination>

    <el-dialog title="电子证书信息" :visible.sync="cerificateVisible">
      <el-table :data="cerInfo">
        <el-table-column
          prop="certificateName"
          label="证书名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="storageType"
          label="入库类别"
          align="center"
          :formatter="storageTypeFormatter"
        ></el-table-column>
        <el-table-column
          prop="storageStatus"
          label="证书状态"
          align="center"
          :formatter="storageStatusFormatter"
        ></el-table-column>
        <el-table-column
          prop="storageTime"
          label="入库时间"
          align="center"
        ></el-table-column>
        <el-table-column label="证书有效期" align="center">
          <template slot-scope="scope">
            {{ scope.row.periodOfValidity }}月
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog title="纸质证书信息" :visible.sync="peperCerVisible">
      <el-table :data="paperInfo">
        <el-table-column
          prop="certificateName"
          label="证书名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="paperStatus"
          label="购买状态"
          :formatter="paperStatusFormatter"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="paperSend"
          label="发放时间"
          align="center"
        ></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import {
  getUserCerPager,
  getPaperCertificateInfo,
  exportUserCertificate,
  exportUserCertificateSelect,
  exportZip
} from "@/api/userCertificate";
import { getAgentChildAll } from "@/api/userInfo";
import permission from "@/directive/permission"; // 权限判断指令
import { defaultPageConfig } from "@/config/pagination";
import MyCollapse from "@/components/Collapse/collapse";
import MyCollapseItem from "@/components/Collapse/collapse-item";
import { getExamUrl } from "@/api/auth";
import { getAgentTree } from "@/api/agentInfo";
import selectTree from "@/components/selectTree";

export default {
  name: "UserCertificate",
  directives: { permission },
  components: {
    MyCollapse,
    MyCollapseItem,
    selectTree
  },
  data() {
    return {
      searchForm: {
        realName: null,
        idNumber: null,
        examName: null,
        agentName: null,
        storageStatus: null,
        paperStatus: null,
        storageTime: null,
        issuingDate: null,
        storageStartDate: null,
        storageEndDate: null,
        issuingStartDate: null,
        issuingEndDate: null,
        assessCompleteStartDate: null,
        assessCompleteEndDate: null,
        isRec: null,
        agentIds: [],
        isExport: null
      },
      exportInfoForm: {},
      exportInfoFormSelect:[],
      exportZipForm: {
        certificateCodes: []
      },
      storageStatusOptions: [
        { label: "未生成", value: 0 },
        { label: "已生成", value: 1 },
        { label: "已入库", value: 3 },
        { label: "已过期", value: 4 }
      ],
      paperStatusOptions: [
        { label: "已发放", value: 2 },
        { label: "未发放", value: 1 }
      ],
      isRecOptions: [
        { label: "未生成", value: 0 },
        { label: "已生成", value: 1 }
      ],
      isExportOptions: [
        { label: "未导出", value: 0 },
        { label: "已导出", value: 1 }
      ],
      cerInfo: [],
      paperInfo: [],
      tableData: [],
      currentPage: 1,
      tableTotal: -1,
      tablePages: 0,
      loading: false,
      tableLayout: defaultPageConfig.layout,
      pageSize: defaultPageConfig.pageSize,
      showUserCerInfo: false,
      showUserPaperCer: false,
      cerificateVisible: false,
      peperCerVisible: false,
      markBthLoading: false,
      unMarkBthLoading: false,
      storageTimes: [],
      issuingDates: [],
      assessCompleteTimes: [],
      pcUrl: null,
      gUrl: null,
      agentList: [],
      agentTreeData: [],
      tableHeight: 600
    };
  },
  watch: {
    storageTimes(val) {
      if (val && val.length > 0) {
        this.searchForm.storageStartDate = val[0] + " 00:00:00";
        this.searchForm.storageEndDate = val[1] + " 23:59:59";
      } else {
        this.searchForm.storageStartDate = null;
        this.searchForm.storageEndDate = null;
      }
    },
    issuingDates(val) {
      if (val && val.length > 0) {
        this.searchForm.issuingStartDate = val[0] + " 00:00:00";
        this.searchForm.issuingEndDate = val[1] + " 23:59:59";
      } else {
        this.searchForm.issuingStartDate = null;
        this.searchForm.issuingEndDate = null;
      }
    },
    assessCompleteTimes(val) {
      if (val && val.length > 0) {
        this.searchForm.assessCompleteStartDate = val[0] + " 00:00:00";
        this.searchForm.assessCompleteEndDate = val[1] + " 23:59:59";
      } else {
        this.searchForm.assessCompleteStartDate = null;
        this.searchForm.assessCompleteEndDate = null;
      }
    },
    cerificateVisible(val) {
      if (!val) {
        this.cerInfo = [];
      }
    },
    peperCerVisible(val) {
      if (!val) {
        this.paperInfo = [];
      }
    }
  },
  computed: {
    dialogTitle() {
      if (this.isFormEdit) {
        return "更新用户";
      } else {
        return "新增用户";
      }
    }
  },
  created() {
    if (localStorage.getItem("pcUrl") && localStorage.getItem("gUrl")) {
      this.pcUrl = localStorage.getItem("pcUrl");
    } else {
      this.getExamUrl();
    }
    let now = new Date();
    let startDate = new Date(now.getFullYear(), now.getMonth() - 3, now.getDate());
    this.assessCompleteTimes = [this.$dayjs(startDate).format('YYYY-MM-DD'), this.$dayjs(now).format('YYYY-MM-DD')]
    this.searchForm.assessCompleteStartDate = this.assessCompleteTimes[0] + " 00:00:00";
    this.searchForm.assessCompleteEndDate = this.assessCompleteTimes[1] + " 23:59:59";
    this.getAgentChildAll();
    this.getAgentTree();
  },
  mounted() {
    let that = this;
    that.$nextTick(() => {
      that.tableHeight =
        document.getElementsByClassName("card-fix-height")[0].clientHeight - 40;
    });
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    setTreeMenu(key, data) {
      if (!key) {
        this.searchForm.agentIds = [];
      } else {
        this.searchForm.agentIds = key;
      }
    },
    handleSizeChange() {
      this.loadUserCerPager();
    },
    handleSelectionChange: function(val) {
      this.exportInfoForm.certificateCodes = val.map(item => {
        return item.certificateCode;
      });
      this.exportInfoForm.userIds = val.map(item => {
        return item.userId;
      });
      this.exportInfoForm.projectIds = val.map(item => {
        return item.projectId;
      });
      this.exportInfoFormSelect = val
      this.exportZipForm.certificateCodes = val.map(item => {
        return item.certificateCode;
      });
    },
    // 格式化入库类别
    storageTypeFormatter(row, column, cellValue) {
      if (cellValue === 1) {
        return "I类证书库";
      } else {
        return "II类证书库";
      }
    },
    // 格式化入库状态
    storageStatusFormatter(row, column, cellValue) {
      if (cellValue) {
        if (cellValue == 0) {
          return "未生成";
        } else if (cellValue === 3) {
          return "已入库";
        } else if (cellValue === 4) {
          return "已过期";
        } else {
          return "已生成";
        }
      }
      return "未生成";
    },
    paperStatusFormatter(row, column, cellValue) {
      if (cellValue) {
        if (cellValue === 2) {
          return "已发放";
        } else {
          return "未发放";
        }
      }
      return "未发放";
    },
    // 初始化用户证书分页
    loadUserCerPager() {
      let that = this;
      that.tableLoading = true;
      getUserCerPager(that.searchForm, {
        page: that.currentPage,
        pageSize: that.pageSize
      })
        .then(res => {
          if (res && res.code === 200) {
            if (res.data) {
              that.tableData = res.data.list;
            } else {
              that.tableData = [];
            }
            if (that.tableData.length < 1) {
              that.tablePages = 0;
              that.tableTotal = 0;
            } else {
              that.tablePages = Number(res.data.pages);
              that.tableTotal = Number(res.data.total);
            }
          } else {
            that.tableData = [];
            that.tablePages = 0;
            that.tableTotal = 0;
          }
        })
        .finally(() => {
          that.tableLoading = false;
        });
    },
    // 查询用户证书分页
    onSearchUserCerPager() {
      let that = this;
      that.tableLoading = true;
      that.currentPage = 1;
      getUserCerPager(that.searchForm, {
        page: that.currentPage,
        pageSize: that.pageSize
      })
        .then(res => {
          if (res && res.code === 200) {
            if (res.data) {
              that.tableData = res.data.list;
            } else {
              that.tableData = [];
            }
            if (that.tableData.length < 1) {
              that.tablePages = 0;
              that.tableTotal = 0;
            } else {
              that.tablePages = Number(res.data.pages);
              that.tableTotal = Number(res.data.total);
            }
          } else {
            that.tableData = [];
            that.tablePages = 0;
            that.tableTotal = 0;
          }
        })
        .finally(() => {
          that.tableLoading = false;
        });
    },
    // 翻页
    onCurrentPageChange(page) {
      this.currentPage = page;
      this.loadUserCerPager();
    },
    showCerInfo(row) {
      this.cerInfo.push(row);
      this.cerificateVisible = true;
    },
    showPaperInfo(row) {
      this.onGetPaperInfo(row.id);
      this.peperCerVisible = true;
    },
    onGetPaperInfo(id) {
      let that = this;
      that.paperInfo = [];
      getPaperCertificateInfo(id).then(res => {
        if (res && res.code === 200) {
          that.paperInfo.push(res.data);
        }
      });
    },
    exportUserCertificateSelect(data){
      const loading = this.$loading({
        lock: true,
        text: "正在下载",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      exportUserCertificateSelect(data)
          .then(res => {
            if (!res || res.status !== 200) {
              this.$message.error("下载文件失败");
              return false;
            }
            const blob = new Blob([res.data], {
              type: "application/octet-stream"
            });
            const downloadElement = document.createElement("a");
            const href = window.URL.createObjectURL(blob);
            let contentDisposition = res.headers["content-disposition"]; //从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
            let patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*");
            let result = patt.exec(contentDisposition);
            let filename = decodeURI(result[1]);
            downloadElement.style.display = "none";
            downloadElement.href = href;
            downloadElement.download = filename; //下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
          })
          .finally(function() {
            loading.close();
          });
    },
    exportInfo() {
      if (this.exportInfoFormSelect.length>0){
        this.exportUserCertificateSelect(this.exportInfoFormSelect)
      }else if (!this.exportInfoForm.certificateCodes || this.exportInfoForm.certificateCodes.length <= 0) {
        this.$confirm(
          "您未勾选任何数据，系统将根据搜索条件进行下载, 是否继续?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        ).then(() => {
          this.exportInfoCall(true);
        });
      } else {
        this.exportInfoCall(false);
      }
    },
    exportInfoCall(flag) {
      const loading = this.$loading({
        lock: true,
        text: "正在下载",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let searchForm = this._.cloneDeep(this.searchForm);
      let exportInfoForm = this._.cloneDeep(this.exportInfoForm);
      if (flag) {
        this._.assign(exportInfoForm, searchForm);
      }
      exportUserCertificate(exportInfoForm)
        .then(res => {
          if (!res || res.status !== 200) {
            this.$message.error("下载文件失败");
            return false;
          }
          const blob = new Blob([res.data], {
            type: "application/octet-stream"
          });
          const downloadElement = document.createElement("a");
          const href = window.URL.createObjectURL(blob);
          let contentDisposition = res.headers["content-disposition"]; //从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
          let patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*");
          let result = patt.exec(contentDisposition);
          let filename = decodeURI(result[1]);
          downloadElement.style.display = "none";
          downloadElement.href = href;
          downloadElement.download = filename; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
        .finally(function() {
          loading.close();
        });
    },
    exportZipHandler() {
      if (
        !this.exportZipForm.certificateCodes ||
        this.exportZipForm.certificateCodes.length <= 0
      ) {
        this.$confirm(
          "您未勾选任何数据，系统将根据搜索条件进行下载, 是否继续?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        ).then(() => {
          this.exportZipCall(true);
        });
      } else {
        this.exportZipCall(false);
      }
    },
    exportZipCall(flag) {
      const loading = this.$loading({
        lock: true,
        text: "正在下载",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let searchForm = this._.cloneDeep(this.searchForm);
      let exportZipForm = this._.cloneDeep(this.exportZipForm);
      if (flag) {
        this._.assign(exportZipForm, searchForm);
      }
      exportZip(exportZipForm)
        .then(res => {
          if (!res) {
            this.$message.error("下载文件失败");
            return false;
          }
          const blob = new Blob([res.data], {
            type: "application/octet-stream"
          });
          const downloadElement = document.createElement("a");
          const href = window.URL.createObjectURL(blob);
          let contentDisposition = res.headers["content-disposition"]; //从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
          let patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*");
          let result = patt.exec(contentDisposition);
          let filename = decodeURI(result[1]);
          downloadElement.style.display = "none";
          downloadElement.href = href;
          downloadElement.download = filename; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
        .finally(function() {
          loading.close();
        });
    },
    viewCer(row) {
      // var code = this.encryption(cerInfo.certificateCode);
      window.open(this.pcUrl + "certificate?userCertificateId=" + row.userCertificateId);
    },
    encryption(code) {
      var c = String.fromCharCode(code.charCodeAt(0) + code.length);
      for (var i = 1; i < code.length; i++) {
        c += String.fromCharCode(code.charCodeAt(i) + code.charCodeAt(i - 1));
      }
      return escape(c);
    },
    getExamUrl() {
      getExamUrl().then(res => {
        if (res && res.code === 200) {
          if (res.data.pcUrl && res.data.gUrl) {
            localStorage.setItem("pcUrl", res.data.pcUrl);
            this.pcUrl = res.data.pcUrl;
            localStorage.setItem("gUrl", res.data.gUrl);
            this.gUrl = res.data.gUrl;
          }
          if (res.data.h5Url) {
            localStorage.setItem("h5Url", res.data.h5Url);
          }
        }
      });
    },
    recStatus(row, column, cellValue) {
      if (cellValue === 1) {
        return "已生成";
      } else {
        return "未生成";
      }
    },
    viewRec(row) {
      window.open(
        "http://g.chinavtic.com/recommendation?userId=" +
          row.userId +
          "&projectId=" +
          row.projectId
      );
    },
    getAgentChildAll() {
      getAgentChildAll().then(res => {
        if (res.code === 200 && res.data) {
          this.agentList = res.data;
          this.searchForm.agentIds.push(this.agentList[0].agentId);
          this.loadUserCerPager();
        }
      });
    },
    cerDateForMatter(row, column, cellValue) {
      if (cellValue) {
        return cellValue.split(" ")[0];
      }
      return "";
    },
    isExportFormatter(row, column, cellValue) {
      if (cellValue === 1) {
        return "已导出";
      } else {
        return "未导出";
      }
    },
    getAgentTree() {
      let that = this;
      getAgentTree(this.searchForm, {}).then(res => {
        if (res && res.code === 200) {
          that.agentTreeData = res.data;
        }
      });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.main-user {
  .searchForm-colleapse {
    border: none;
    /deep/ .el-collapse-item__header {
      line-height: unset;
      border: none;
      cursor: auto;
    }
    /deep/ .el-form-item {
      margin-bottom: 0;
    }
    /deep/ .el-collapse-item__arrow.el-icon-arrow-right {
      cursor: pointer;
      &:before {
        content: "更多";
        color: #e93c27;
        font-size: 12px;
      }
      &.is-active {
        transform: unset;
      }
    }
    /deep/ .el-collapse-item__wrap {
      border: none;
    }
  }
  /deep/ .search-form .el-form-item#myselfAgent .el-form-item__content {
    .el-select {
      width: 230px;
      .el-select__tags-text {
        display: inline-block;
        max-width: 120px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .el-tag__close.el-icon-close {
        top: -6px;
      }
    }
  }
  .dashboard {
    &-container {
      margin: 30px;
    }
    &-text {
      font-size: 30px;
      line-height: 46px;
    }
  }
  /deep/ .el-card__body {
    overflow: hidden !important;
    .el-table--enable-row-transition {
      overflow: hidden !important;
    }
  }
  ::-webkit-scrollbar {
    background-color: #f8f8ff;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #dedfe9;
  }
  .card-fix-height {
    position: relative;
    height: calc(100vh - 50px - 274px);
  }
  .button {
    padding-bottom: 20px;
  }

  .demo-table-expand {
    font-size: 0;
  }

  .demo-table-expand label {
    width: 110px;
    color: #99a9bf;
  }

  /deep/ .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
}
</style>
